var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedication = function SvgMedication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M22.5 15.5a9.9 9.9 0 0 0-5 1.353V9.25a8.75 8.75 0 0 0-17.5 0v17.5a8.749 8.749 0 0 0 15.357 5.735A9.995 9.995 0 1 0 22.5 15.5m0 2.5a7.506 7.506 0 0 1 7.387 6.25H15.114A7.506 7.506 0 0 1 22.5 18m-20-8.75a6.25 6.25 0 0 1 12.5 0v7.5H2.5zM8.75 33a6.26 6.26 0 0 1-6.25-6.25v-7.5h12.206a9.95 9.95 0 0 0-.905 11.164A6.24 6.24 0 0 1 8.75 33m13.75 0a7.506 7.506 0 0 1-7.387-6.25h14.775A7.506 7.506 0 0 1 22.5 33"
  })));
};
export default SvgMedication;